import { twMerge } from 'tailwind-merge';

function PageContainer({ children, className }: React.HTMLAttributes<HTMLDivElement>) {
  return (
    <div id="page-content-wrapper" className={twMerge('h-fit w-fit grow overflow-hidden px-4 pt-8 md:p-8', className)}>
      {children}
    </div>
  );
}

export { PageContainer };
